<template>
  <postTransaction></postTransaction>
</template>

<script>
import postTransaction from '@/views/mci/cashier/postTransactionSplited/index'
export default {
  components: {
    postTransaction
  }
}
</script>

